import React, { useContext } from 'react';
import { defineMessages, t } from '@sm/intl';
import { createUseStyles } from 'react-jss';
import { StaticContext } from '@sm/webassets/StaticContext';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Button } from '@wds/button';
import { generateMetricsAttribute } from '@sm/metrics';
import { createURL } from '@sm/utils';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';
import researchSVG from '~static/images/logo-research.svg';
import { getSrc } from '~app/helpers/assetLoading';

const COPY = defineMessages({
  THANK_YOU: {
    id: 'SurveyThanks.Research.ThankYou',
    defaultMessage: 'Thank you for taking the survey.',
    description:
      '[Type: Header][vis: high] - The only message on the webpage. Used on a Nonbranded webpage to say thank you to survey respondents and signal the end of the survey.',
  },

  POWERED_BY: {
    id: 'SurveyThanks.Research.PoweredBy',
    defaultMessage: 'Powered by',
    description:
      '[Type: Label][Vis: med] - This figure of speech is used to introduce and display the SurveyMonkey Logo',
  },
  EMBEDDED_CTA: {
    id: 'SurveyThanks.Research.EmbeddedCTA',
    defaultMessage: 'Learn more',
    description:
      '[Type: Label][Vis: med] - This is the phrase used inside a button that directs views to a signup page',
  },
});

const useStyles = createUseStyles((theme: CmsWrenchTheme) => {
  return {
    container: {
      height: theme.util.fullHeight,
    },
    researchLogo: {
      height: 40,
      width: 200,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundImage: `url(${getSrc(researchSVG)})`,
    },
  };
});

function Research(): React.ReactElement {
  const classes = useStyles();

  const utSource = 'survey-thanks';
  const utSource2 = 'Research';

  const {
    smParams: { surveyId, collectorId, respondentId },
    templateType,
  } = useContext(StaticContext);

  return (
    <Box className={classes.container} display="flex" flexAlign="center" flexJustify="center" flexDirection="column">
      <Typography color="dark" component="div" variant="cardTitle">
        {t(COPY.THANK_YOU)}
      </Typography>
      <Typography color="darkMuted" component="div" variant="body">
        {t(COPY.POWERED_BY)}
      </Typography>
      <Box className={classes.researchLogo} m={1}>
        &nbsp;
      </Box>
      <Button
        size="sm"
        href={createURL('https://www.surveymonkey.com', {
          ut_source: utSource,
          ut_source2: utSource2,
          ut_ctatext: COPY.EMBEDDED_CTA.defaultMessage,
        })}
        data-sm-metrics={generateMetricsAttribute({
          data: {
            amplitudeEvent: 'endpage user interaction',
            itemSelected: 'homepage cta',
            templateType,
            surveyId,
            collectorId,
            respondentId,
            log: {
              message: `${utSource}-${utSource2}-${COPY.EMBEDDED_CTA.defaultMessage}`,
            },
          },
        })}
        variant="secondary"
      >
        {t(COPY.EMBEDDED_CTA)}
      </Button>
    </Box>
  );
}

export default Research;
